module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-handle.4216743a.jpg";